import {
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { t } from "i18next";
import { FaFileDownload } from "react-icons/fa";
import { PdfPreview } from "./PdfPreview";

export const PreviewPdfModal = ({
  url,
  documentName,
  initialPage,
  onClose,
}: {
  url: string;
  documentName?: string;
  initialPage?: number;
  onClose: () => void;
}) => {
  // An anchor covers both source kinds: a presigned link already carries Content-Disposition: attachment,
  // and a same-origin blob: URL (e.g. the bid report) is saved by the download attribute rather than
  // opened in a tab, which window.open would have done.
  const download = () => {
    const link = window.document.createElement("a");
    link.href = url;
    link.download = documentName ?? "document.pdf";
    link.rel = "noreferrer";
    link.click();
  };

  return (
    <Modal isOpen={true} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent height="95%">
        <ModalHeader display="flex" alignItems="center" gap="4" pr="16">
          <Text fontSize="md" flex="1" noOfLines={1}>
            {documentName ?? t("PDF preview")}
          </Text>
          <Button
            size="sm"
            variant="outline"
            fontWeight="normal"
            leftIcon={<Icon as={FaFileDownload} />}
            onClick={download}
          >
            {t("Download")}
          </Button>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody height="full" width="full" pb="6">
          <PdfPreview source={url} initialPage={initialPage} onDownload={download} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
